import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { TransportType } from 'src/types/transport';
import { progressSteps } from './constants';
import { checkPermission } from 'src/utils/checkPermission';
import { DuplicateIcon } from 'src/components/SkladonIcon/SmallIcons';

export interface TopBlockPropsType {
    data: TransportType | null;
    idTransport: string | undefined;
    newTransport: boolean;
    disableEdit: boolean;
    handleSave: () => void;
    handleOrderShipment: () => void;
    handleClone: () => void;
    orderShipmentBusy?: boolean;
    activeTab: string;
    handleChangeTab: (value: string) => void;
    permissionCreate: boolean;
    permissionOrderShipment: boolean;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    if (props.newTransport) {
        return null;
    }

    const shipmentPending = Number(props.data?.SHIPMENT_PENDING) === 1;

    const tabs = progressSteps.filter((tab) => {
        if (tab.value === 'apiCalls') {
            return checkPermission('TRANSPORT.API_CALLS.LIST');
        }
        if (tab.value === 'events') {
            return checkPermission('TRANSPORT.EVENTS.LIST');
        }
        return true;
    });

    return (
        <>
            <BodyTopBlock
                tabs={tabs}
                selectTab={props.activeTab}
                onChangeTab={props.handleChangeTab}
                actions={[
                    {
                        tooltip: translate('transportDetail.action.cloneTransport'),
                        onClick: () => {
                            props.handleClone();
                        },
                        icon: <DuplicateIcon />,
                        hidden: !props.permissionCreate,
                        variant: 'outlined',
                        'data-testid': 'transport-clone-btn',
                    },
                    {
                        label: shipmentPending
                            ? translate('transportDetail.action.orderShipmentPending')
                            : translate('transportDetail.action.orderShipment'),
                        onClick: () => {
                            props.handleOrderShipment();
                        },
                        hidden: !props.permissionOrderShipment,
                        disabled: props.orderShipmentBusy || shipmentPending,
                        variant: 'outlined',
                        'data-testid': 'transport-order-shipment-btn',
                    },
                    {
                        label: translate('transportDetail.action.save'),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: props.disableEdit,
                        'data-testid': 'transport-save-btn',
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
